<template>
  <article id="about">
		<div class="container-xs is-centered">
			<h1>A little bit about me</h1>
			<div class="grid-row grid-gutter-sm center-align">
				<div class="grid-col col-1-of-3">
					<img class="profile-pic" src="@/assets/img/portraits/blake-3.jpg" alt="Me"/>
				</div>
				<div class="grid-col col-1-of-3">
					<img class="profile-pic" src="@/assets/img/portraits/blake-1.jpg" alt="Me"/>
					<span>Oh hi there!</span>
				</div>
				<div class="grid-col col-1-of-3">
					<img class="profile-pic" src="@/assets/img/portraits/blake-4.jpg" alt="Me"/>
				</div>
			</div>
		</div>
		<div class="container-med is-centered">
			<h2>What I've been up to</h2>
			<p>I'm currently the Senior Front-End Developer on RL Solutions' marketing team, where I've been working for the past five years.  I've worked on a wide variety of projects, including, but not limited to: rebuilding their corporate website, co-developing their client engagement platform, and developing all digital conference experiences. I also standardized email templates for corporate campaigns, and created digital office tools such as an office newsboard and a visitor registration application.</p>
			<p>Previously, I was a Web Developer at the Canadian Broadcasting Corporation (CBC), where I worked with various programs, including the <em>George Stroumboulopolous Tonight</em> show, the Sochi 2014 Winter Olympics, and <em>CBC Connects</em>.</p>
			<h2>Education &amp; skills</h2>
			<p>I graduated from the University of Toronto with a Specialist degree in Digital Enterprise Management, and from Sheridan College with a certificate in Digital Communication. As a result, I have both the development tools and the business strategy necessary to ensure projects are successful from start to finish.</p>
			<p>I've worked extensively with the following tools:</p>
			<ul>
				<li>
					<strong>Languages:</strong></br>
					HTML, CSS/SCSS/SASS, JavaScript, PHP
				</li>
				<li>
					<strong>Popular JS libraries and frameworks</strong></br>
					VueJs, jQuery, Phaser
				</li>
				<li>
					<strong>Marketing Automation Systems</strong></br>
					Pardot (Salesforce-based email system), including email testing through Litmus
				</li>
				<li>
					<strong>Code versioning/repositories</strong></br>
					GitHub, Tortoise SVN
				</li>
				<li>
					<strong>Content Management Systems</strong></br>
					Kentico CMS, Bolt CMS, Wordpress, Expression Engine, Movable Type
				</li>
			</ul>
			<h2>Beyond work</h2>
			<p>I want to help foster a work environment where people feel like more than just distant colleagues. At RL&nbsp;Solutions, outside of work hours, I created and participated in multiple clubs to enhance camaraderie within the office. This included hosting a weekly fitness bootcamp, and running a tabletop roleplaying board games club to foster discussions about strategizing, skill growing, and team-building—all while having fun, to boot.</p>
			<h2>Get in touch</h2>
			<p>Have any questions or comments? Drop me a line through my <a target="_blank" href="https://ca.linkedin.com/in/blake-lipson-6111b468">LinkedIn account</a>, or send an email to&nbsp;<a target="_blank" href="mailto:blake@blakelipson.com">blake@blakelipson.com</a>.</p>

		</div>
	</article>
</template>

<script>
export default {
	name: 'About'
}
</script>

<style lang="scss">
@import 'src/assets/css/modules/colors';
#about {
	.profile-pic {
		width: 125px;
		height: 125px;
		border-radius: 50%;
		& + span {
			display: block;
			font-size: 0.875rem;
			font-style: italic;
			margin-top: 0.75rem;
		}
	}
	strong {
		font-weight: 500;
	}
	a {
		color: $teal;
		font-weight: 500;
		&:hover, &:focus {
			text-decoration: underline;
		}
	}
	h1 {
		margin: 0 0 2rem;
		text-align: center;
	}
	h2 {
		color: $teal;
		margin: 1.75rem 0 1rem;
	}
	p {
		line-height: 1.8;
	}
	li {
		line-height: 1.6;
		margin-bottom: 0.5rem;
		&:last-child {
			margin-bottom: 0;
		}
	}
}
</style>